import { faAddressBook, faBox, faCalendarDay, faComments, faInfo } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const SelectedFieldIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faInfo} color={props.color || 'black'} />
  )
}
